import { FC } from 'react';

interface ResetSettingsModalProps {
  onConfirm: () => void;
  onClose: () => void;
}

// Confirmation shown before Restore Defaults wipes every App Default.
const ResetSettingsModal: FC<ResetSettingsModalProps> = ({ onConfirm, onClose }) => (
  <div className="settings-modal-overlay" onClick={onClose}>
    <div
      className="settings-modal"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="settings-modal-title"
      aria-describedby="settings-modal-text"
      onClick={(event) => event.stopPropagation()}
    >
      <img src="assets/icon/settings/warning.svg" alt="" className="settings-modal__icon" />
      <div className="settings-modal__text">
        <h2 id="settings-modal-title" className="settings-modal__title">
          Reset Settings?
        </h2>
        <p id="settings-modal-text" className="settings-modal__subtext">
          This action cannot be undone, settings will be reset to the app default state.
        </p>
      </div>
      <div className="settings-modal__actions">
        <button
          className="settings-modal__button settings-modal__button--primary"
          onClick={onConfirm}
        >
          Confirm
        </button>
        <button
          className="settings-modal__button settings-modal__button--outline"
          onClick={onClose}
        >
          Back
        </button>
      </div>
    </div>
  </div>
);

export default ResetSettingsModal;
